import { views } from '@/v-shop/autoloader'

export default () => [
	{
		path: '/',
		name: 'home',
		component: views.Home,
	},
]
